import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const getDefaultState = () => {
  return {
    corporateId:'',
    primaryContactID:'',
    technicalContactID:'',
    financialContactID:'',
    businessPrimaryContactDetailID:'',
    transactionalProfileID:'',
    websiteApplicationFormID:'',
    webContentFormID:'',
    directorID:'',
    shareholderID:'',
    cryptoCurrencyID:[],
    bankingInfoID:'',
    documents: [
      {
        name: "Supported Documents",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: [
          "Certificate of Incorporation (CD)",
          "Certificate of change of name, if applicable"
        ],
        status: [],
        deletedIndex: [],
        information:
          "Corporate documents of the company, registration number, and date of incorporation"
      },
      {
        name: "Proof of Address",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: [
          "Certificate of Incorporation (POA)",
          "Certificate of Incumbency (POA)",
          "Annual Return Statement (POA)"
        ],
        status: [],
        deletedIndex: [],
        information: "Proof of address stated in any of the following documents"
      },
      {
        name: "Proof of Directorship",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: [
          "Certificate of Incorporation (POD)",
          "Certificate of Incumbency (POD)",
          "Annual Return Statement (POD)"
        ],
        status: [],
        deletedIndex: [],
        information:
          "Proof of directorship, not older than one year, in form of a government-issued document for example"
      },
      {
        name: "Director Identification",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: [
          "Passport",
          "Driving License(Both Sides)",
          "National ID Card(Both Sides)",
          "Resident Permit Card (Both Sides)"
        ],
        status: [],
        deletedIndex: [],
        information:
          "Copy of identification for all directors, which must be valid for next 3 months. We accept scanned copies if the photo is taken straight from the top. The images must be in color and of high quality. No part of the image may be covered."
      },
      {
        name: "Proof of Residence",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: [
          "Bank society statement",
          "Building society statement",
          "Benefits agency",
          "Credit Card statement",
          "Full Driving License (can only be used once either as Photo ID or POR - not both)",
          "Home insurance certificate",
          "Motor insurance certificate",
          "Inland Tax Revenue notification",
          "Electricity bill",
          "Council Tax Bill",
          "Gas Bill",
          "Water bill",
          "Landline telephone bill"
        ],
        status: [],
        deletedIndex: [],
        information:
          "Proof of Residence (POR) for all directors, which must be issued within the last 3 months."
      },
      {
        name: "Company Share Registry",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: [
          "Company share registry",
          "Certificate of Incorporation",
          "Proof of registered address",
          "Proof of Directorship",
          "Share registry"
        ],
        status: [],
        deletedIndex: [],
        information:
          "Proof of Shareholders, not older than one year. The company share registry (share ledger) with a list of Shareholders. If the shareholder is another legal entity (company), we require one of the documents in dropdown. With these documents, we identify the ultimate beneficial owners"
      },
      {
        name: "IP/POR for UBOs",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: ["Copy of ID", "Copy of POR"],
        status: [],
        deletedIndex: [],
        information:
          "Copy of ID and POR for all UBOs controlling 25% or more of the company, as per our requirements"
      },
      {
        name: "Power of Attorney",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: ["Power of Attorney"],
        status: [],
        deletedIndex: [],
        information: "Power of Attorney, If applicable."
      },
      {
        name: "IP/POR of Attorney",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: ["Copy of ID (Attorney)", "Copy of POR (Attorney)"],
        status: [],
        deletedIndex: [],
        information:
          "Copy of ID and POR of the attorney, as per our requirements, if applicable"
      },
      {
        name: "Bank Statement",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: ["Bank Account Statement"],
        status: [],
        deletedIndex: [],
        information:
          "Bank account statement. The statement should show transactions for the last 3 months."
      },
      {
        name: "Acquirer",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: ["Acquirer Statement"],
        status: [],
        deletedIndex: [],
        information:
          "Previous acquirer statements for the last 6 months. If applicable "
      },
      {
        name: "Annual Report",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: false,
        dropdown: ["Annual Report", "Annual Audited Accounts"],
        status: [],
        deletedIndex: [],
        information: "Annual report and annual audited accounts, if  applicable"
      },
      {
        name: "Business License",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: ["Business License"],
        status: [],
        deletedIndex: [],
        information:
        "A copy of business license, if applicable, issued in the name of the company."
      },
      {
        name: "AML and Operation Policies",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: ["AML and Operation Policies"],
        status: [],
        deletedIndex: [],
        information: "AML and operation policies , if applicable."
      },
      {
        name: "VAT Tax Numbers",
        valueToSelect: "",
        filetype: [],
        fileLoader: false,
        required: true,
        dropdown: ["VAT or TAX Number"],
        status: [],
        deletedIndex: [],
        information: "VAT/Tax numbers, if applicable"
      }
    ],
    // data to handle errors
    corporateInfoError: false,
    contactDetailsError: false,
    shareholderDetailsError: false,
    directorsDetailsError: false,
    businessProfileError: false,
    transactionalProfileError: false,
    websiteDetailsError: false,
    websiteContentError: false,
    paymentInstructionsError: false,
    bankingInformationError: false,
    // data to handle errors
    
    // uploadedFiles:[],
    // corporate: "",
    // selectedFile:[],
    
    forgotToken: "",
    forgotEmail: "",
    
    user_id: "",
    stepperIndex: 1,
    form_id: "",
    stepperCount: 1,
    is_onboarded: 0,
    // corporationForm: {
    //   corporate_name: "",
    //   registeration_number: "",
    //   incorporation_date: "",
    //   registered_address: "",
    //   city: "",
    //   country: "",
    //   postal_code: "",
    //   VAT_number: "",
    //   business_address: "",
    //   business_city: "",
    //   business_country: "",
    //   business_postal_code: ""
    // },
    primaryContact: {
      contact_name: "",
      phone_no: "",
      email: "",
      position: ""
    },
    financialContact: {
      contact_name: "",
      phone_no: "",
      email: "",
      position: ""
    },
    technicalContact: {
      contact_name: "",
      phone_no: "",
      email: "",
      position: ""
    },
    directorsDetails: [
      {
        form_id: 1,
        first_name: "",
        last_name: "",
        date_of_birth: "",
        passport_no: "",
        passport_country: "",
        residing_address: "",
        city: "",
        country: "",
        postal_code: "",
        relative_public_figure: "",
        is_US_resident: false
      }
    ],
    shareholderDetails: [
      {
        form_id: 1,
        percentage: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        passport_no: "",
        passport_country: "",
        residing_address: "",
        city: "",
        country: "",
        postal_code: "",
        relative_public_figure: "",
        is_US_resident: false
      }
    ],
    businessProfile: {
      services_or_goods: "",
      business_license: "",
      industries: "",
      companies_and_websites: ""
    },
    transactionalProfile: {},
    websiteDetails: {
      merchant_website: "",
      business_type: "",
      // ip_address: "",
      // descriptor: "",
      customer_support_email: "",
      // city: "",
      chargeback_notification_email: "",
      business_time_period: "",
      // processor_name: "",
      // monthly_sales_volume: "",
      // monthly_transaction: "",
      processing_currency: {
        eur: false,
        usd: false,
        gbp: false,
        other: ""
      },
      settlement_currency: {
        eur: false,
        usd: false,
        gbp: false,
        other: ""
      }
      // is_payment_by_card: false,
      // other_payment: "",
      // preauthorize_trx: "",
    },
    websiteContent: {
      service_product: "",
      payment_model: "",
      customer_charged_time: "",
      customer_countries: ""
    },
    cryptoCurrencyWallet: [
      {
        form_id: 1,
        wallet_detail: "",
        crypto_currency: ""
      }
    ],
    bankingInformation: [
      {
        form_id: 1,
        key: Date.now(),
        bank_name: "",
        bank_address: "",
        bank_city: "",
        bank_country: "",
        swift: "",
        iban: "",
        account_name: "",
        account_number: ""
      }
    ]
  };
};

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: getDefaultState(),
  mutations: {
    // reset state
    resetStore: state => {
      Object.assign(state, getDefaultState());
    },

    // updates the index of main form stepper
    updateIndex: (state, index) => {
      state.stepperIndex = index;
    },
    incrementStepper: state => {
      state.stepperCount++;
    },
    uploadFile: (state, payload) => {
      state.documents = payload;
    },

    //muatations to update errors states
    updateCorporateInfoError(state, val) {
      state.corporateInfoError = val;
    },

    updateContactDetailsError(state, val) {
      state.contactDetailsError = val;
    },
    updateShareholdersDetailsError(state, val) {
      state.shareholderDetailsError = val;
    },
    updateDirectorsDetailsError(state, val) {
      state.directorsDetailsError = val;
    },
    updateBusinessProfileError(state, val) {
      state.businessProfileError = val;
    },
    updateTransactionalProfileError(state, val) {
      state.transactionalProfileError = val;
    },
    updateWebsiteDetailsError(state, val) {
      state.websiteDetailsError = val;
    },
    updateWebsiteContentError(state, val) {
      state.websiteContentError = val;
    },
    updatePaymentInstructionsError(state, val) {
      state.paymentInstructionsError = val;
    },
    updateBankingInformationError(state, val) {
      state.bankingInformationError = val;
    },
    // mutations to update errors states ends here

    updateUserId: (state, user_id) => {
      state.user_id = user_id;
    },
    // formId(state, form_id){
    //     state.formID = form_id;
    // },
    updateFormId: (state, formId) => {
      state.form_id = formId;
    },

    //updates the corporatiion form of first main stepper
    updateCorporateInfo: (state, form) => {
      state.corporationForm = form;
    },
    //updates the primary contact details on first main stepper
    updatePrimaryContact: (state, form) => {
      state.primaryContact = form;
    },
    //updates the financial contact details on first main stepper
    updateFinancialContact: (state, form) => {
      state.financialContact = form;
    },
    //updates the Technical contact details on first main stepper
    updateTechnicalContact: (state, form) => {
      state.technicalContact = form;
    },
    //updates the Director details on first main stepper
    updateDirectorsDetails: (state, form) => {
      state.directorsDetails = form;
    },
    //updates the shareholder details on first main stepper
    updateShareholderDetails: (state, form) => {
      state.shareholderDetails = form;
    },
    //updates the business profile details on second main stepper
    updateBusinessProfile: (state, form) => {
      state.businessProfile = form;
    },
    //updates the transactions details on third main stepper
    updateTransactionalProfile: (state, form) => {
      state.transactionalProfile = form;
    },
    //updates the website application details on fourth main stepper
    updateWebsiteDetails: (state, form) => {
      state.websiteDetails = form;
    },
    //updates the website content details on fourth main stepper
    updateWebsiteContent: (state, form) => {
      state.websiteContent = form;
    },
    //updates the crypto currency details on fifth main stepper
    updateCryptoCurrencyWallet: (state, form) => {
      state.cryptoCurrencyWallet = form;
    },
    //updates the bbanking details on fifth main stepper
    updateBankingInformation: (state, form) => {
      state.bankingInformation = form;
    },

    /* Forgot password mutation */
    forgotTokenMutation(state, payload) {
      state.forgotToken = payload.message;
      state.forgotEmail = payload.email;
    },
    updateCorporateInfoId(state,corporateId){
      state.corporateId = corporateId
    },
    updatePrimaryContactId(state, primaryID){
      state.primaryContactID = primaryID;
    },
    updateFinancialContactId(state, financialID){
      state.financialContactID = financialID;
    },
    updateTechnicalContactId(state, technicalID){
      state.technicalContactID = technicalID;
    },
    updateBusinessPrimaryId(state, businessPrimaryID){
      state.businessPrimaryContactDetailID = businessPrimaryID;
    },
    updateTransactionalId(state, transactionID){
      state.transactionalProfileID = transactionID;
    },
    updateWebAppId(state, webAppID){
      state.websiteApplicationFormID = webAppID;
    },
    updateWebContentId(state, webContentID){
      state.webContentFormID = webContentID;
    },
    updateCryptoId(state,cryptoID){
      state.cryptoCurrencyID.push(cryptoID);
    },
    updateCorporateDuplicate(state,index){
      state.corporateInfoError=true;
    }
  },
  actions: {
    
    updateCorporateDuplicate: ({ commit }, index) => {
      commit("updateCorporateDuplicate", index);
    },
    resetStore: ({ commit }) => {
      commit("resetStore");
    },
    updateIndex: ({ commit }, index) => {
      commit("updateIndex", index);
    },
    incrementStepper: ({ commit }) => {
      commit("incrementStepper");
    },

    // actions to commit mutations for error states
    updateCorporateInfoError({ commit }, val) {
      commit("updateCorporateInfoError", val);
    },
    updateContactDetailsError({ commit }, val) {
      commit("updateContactDetailsError", val);
    },
    updateShareholdersDetailsError({ commit }, val) {
      commit("updateShareholdersDetailsError", val);
    },
    updateDirectorsDetailsError({ commit }, val) {
      commit("updateDirectorsDetailsError", val);
    },
    updateBusinessProfileError({ commit }, val) {
      commit("updateBusinessProfileError", val);
    },
    updateTransactionalProfileError({ commit }, val) {
      commit("updateTransactionalProfileError", val);
    },
    updateWebsiteDetailsError({ commit }, val) {
      commit("updateWebsiteDetailsError", val);
    },
    updateWebsiteContentError({ commit }, val) {
      commit("updateWebsiteContentError", val);
    },
    updatePaymentInstructionsError({ commit }, val) {
      commit("updatePaymentInstructionsError", val);
    },
    updateBankingInformationError({ commit }, val) {
      commit("updateBankingInformationError", val);
    },
    // actions to commit mutations for error states end here

    updateUser ({ commit }, user){
        // console.log(user.userFormData,"store");
      commit("updateUserId", user.user_id);
      commit("updateFormId", user.userFormData[0].application_form[0].id);
      commit("updateCorporateInfoId", user.userFormData[0].corporate_information.id);
      commit("updatePrimaryContactId", user.userFormData[0].primary_contact_detail.id);
      commit("updateFinancialContactId", user.userFormData[0].financial_contact_detail.id);
      commit("updateTechnicalContactId", user.userFormData[0].technical_content_detail.id);
      commit("updateBusinessPrimaryId", user.userFormData[0].business_primary_contact_detail.id);
      commit("updateTransactionalId", user.userFormData[0].transactional_profile.id);
      // commit("updateWebAppId", user.userFormData[0].website_application_form.id);
      // commit("updateWebContentId", user.userFormData[0].web_content_form.id);
      // user.userFormData[0].crypto_currency_wallet.filter((item)=>{
      //   commit("updateCryptoId",item.id);
      // })
      // commit("updateDirectorId", user.userFormData[0].director);
      // commit("updateShareholderId", user.userFormData[0].shareholder);
      // commit("updateCryptoCurrencyId", user.userFormData[0].crypto_currency_wallet);
      // commit("updateBankingInfoId", user.userFormData[0].banking_information);
    },
    // updateFormId: ({ commit }, formId) => {
    //   commit("updateFormId", formId);
    // },
    updateCorporateInfo: ({ commit }, form) => {
      commit("updateCorporateInfo", form);
    },
    updatePrimaryContact: ({ commit }, form) => {
      commit("updatePrimaryContact", form);
    },
    updateFinancialContact: ({ commit }, form) => {
      commit("updateFinancialContact", form);
    },
    updateTechnicalContact: ({ commit }, form) => {
      commit("updateTechnicalContact", form);
    },
    updateDirectorsDetails: ({ commit }, form) => {
      commit("updateDirectorsDetails", form);
    },
    updateShareholderDetails: ({ commit }, form) => {
      commit("updateShareholderDetails", form);
    },
    updateBusinessProfile: ({ commit }, form) => {
      commit("updateBusinessProfile", form);
    },
    updateTransactionalProfile: ({ commit }, form) => {
      commit("updateTransactionalProfile", form);
    },
    updateWebsiteDetails: ({ commit }, form) => {
      commit("updateWebsiteDetails", form);
    },
    updateWebsiteContent: ({ commit }, form) => {
      commit("updateWebsiteContent", form);
    },
    updateCryptoCurrencyWallet: ({ commit }, form) => {
      commit("updateCryptoCurrencyWallet", form);
    },
    updateBankingInformation: ({ commit }, form) => {
      commit("updateBankingInformation", form);
    },

    /* Forgot password, this route sends email to the user */
    forgotPwd({ commit, state }, email) {
      return new Promise((resolve, reject) => {
        axios
          .post("/forgot_password", email)
          .then(res => {
            resolve(res);
            commit("forgotTokenMutation", res.data.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /* This route receives token in parameter
        and resets password */
    resetPassword({ commit, state }, passwordObj) {
      return new Promise((resolve, reject) => {
        console.log()
        axios
          .post("/reset_password" , passwordObj)
          .then(res => {
            resolve(res);
            state.forgotToken = "";
            // router.push({ name: "signin" });
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    uploadFile({ commit }, payload) {
      commit("uploadFile", payload);
    },

   
  },

  getters: {
    getUserId: state => {
      return state.user_id;
    },
    getFormId: state => {
      return state.form_id;
    },
    getCorporateID: state => {
      return state.corporateId
    },
    getPrimaryID: state => {
      return state.primaryContactID
    },
    getTechnicalID: state => {
      return state.technicalContactID
    },
    getFinancialID: state => {
      return state.financialContactID
    },
    getBusinessPrimaryID: state => {
      return state.businessPrimaryContactDetailID
    },
    getTransactionID: state => {
      return state.transactionalProfileID
    },
    getWebAppID: state => {
      return state.websiteApplicationFormID
    },
    getWebContentID: state => {
      return state.webContentFormID
    },
    getStepperCount: state => {
      return state.stepperCount;
    },
    // getters for error starts here
    getCorporateInfoError: state => {
      return state.corporateInfoError;
    },
    getPrimaryContactError: state => {
      return state.contactDetailsError;
    },
    getDirectorsDetailsError: state => {
      return state.directorsDetailsError;
    },
    getShareholdersDetailsError: state => {
      return state.shareholderDetailsError;
    },
    getBusinessProfileError: state => {
      return state.businessProfileError;
    },
    getTransactionalProfileError: state => {
      return state.transactionalProfileError;
    },
    getWebsiteDetailsError: state => {
      return state.websiteDetailsError;
    },
    getWebsiteContentError: state => {
      return state.websiteContentError;
    },
    getPaymentInstructionsError: state => {
      return state.paymentInstructionsError;
    },
    getBankingInformationError: state => {
      return state.bankingInformationError;
    },
    // getters for errors end here
    getCorporateInfo: state => {
      return state.corporationForm;
    },
    getPrimaryContact: state => {
      return state.primaryContact;
    },
    getFinancialContact: state => {
      return state.financialContact;
    },
    getTechnicalContact: state => {
      return state.technicalContact;
    },
    getDirectorsDetails: state => {
      return state.directorsDetails;
    },
    getShareholdersDetails: state => {
      return state.shareholderDetails;
    },
    getBusinessProfile: state => {
      return state.businessProfile;
    },
    getTransactionalProfile: state => {
      return state.transactionalProfile;
    },
    getWebsiteDetails: state => {
      return state.websiteDetails;
    },
    getWebsiteContent: state => {
      return state.websiteContent;
    },
    getCryptoCurrencyWallet: state => {
      return state.cryptoCurrencyWallet;
    },
    getBankingInformation: state => {
      return state.bankingInformation;
    },
    getCryptoID: state =>{
      return state.cryptoCurrencyID
    },

    getDocument: state => {
      return state.documents;
    },
    // getCorporateName: state => {
    //   return state.corporate;
    // },
    // getSelectedFile: state => {
    //   return state.selectedFile;
    // }
  },
  modules: {}
});
